import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/venues',
    id : null,
    name : "",
    address : "",
    latitude : "",
    longitude : "",
    phone : "",
    fax : "",
    details : ""
});

